/**
 * Capability filters supported by the available-number search.
 * Mirrors the Voice/SMS/MMS filter the old (phlo) console exposed.
 */
export const CAPABILITY_OPTIONS = [
  { value: 'voice', label: 'Voice' },
  { value: 'sms', label: 'SMS' },
  { value: 'mms', label: 'MMS' },
] as const

export type Capability = (typeof CAPABILITY_OPTIONS)[number]['value']

/**
 * Default capability selection. Kept as voice-only to preserve the previous
 * new-console behaviour (services=voice) until the user changes it.
 */
export const DEFAULT_SERVICES: Capability[] = ['voice']

interface AvailableNumbersParamArgs {
  country: string
  search: string
  services: Capability[]
  numberType: string
  limit?: number
  offset?: number
  numberStartswith?: string
}

/**
 * Builds the query params for the available-number search endpoint.
 * Pure so it can be unit-tested without a React/query harness.
 */
export const buildAvailableNumbersParams = ({
  country,
  search,
  services,
  numberType,
  limit,
  offset,
  numberStartswith,
}: AvailableNumbersParamArgs): Record<string, string> => {
  const params: Record<string, string> = {
    country_iso: country,
    search_param: search,
    services: services.length > 0 ? services.join(',') : DEFAULT_SERVICES.join(','),
  }
  if (limit !== undefined) params.limit = limit.toString()
  if (offset !== undefined) params.offset = offset.toString()
  if (numberType !== 'all') params.number_type = numberType
  if (numberStartswith) params.number_startswith = numberStartswith
  return params
}
